export default "__VITE_ASSET__To2N31Sy__"